<ul class="menu-steps">
  <li class="menu-step">
    @if (showStep1Link) {
      <a class="menu-step-link" [routerLink]="step1Link" routerLinkActive="active">
        <ng-template [ngTemplateOutlet]="menuStep1"></ng-template>
      </a>
    }
    @if (!showStep1Link) {
      <span class="menu-step-link">
        <ng-template [ngTemplateOutlet]="menuStep1"></ng-template>
      </span>
    }
  </li>

  <li class="menu-step">
    @if (showStep2Link) {
      <a class="menu-step-link" [routerLink]="step2Link" routerLinkActive="active">
        <ng-template [ngTemplateOutlet]="menuStep2"></ng-template>
      </a>
    }
    @if (!showStep2Link) {
      <span class="menu-step-link">
        <ng-template [ngTemplateOutlet]="menuStep2"></ng-template>
      </span>
    }
  </li>
</ul>


<ng-template #menuStep1>
  <span class="menu-step-icon">
    <span class="menu-step-count far fa-file-alt"></span>
  </span>
  <span class="menu-step-title">{{ 'Federation.New.Steps.Step1' | translate }}</span>
</ng-template>

<ng-template #menuStep2>
  <span class="menu-step-icon">
    <span class="menu-step-count fas fa-star"></span>
  </span>
  <span class="menu-step-title">{{ 'Federation.New.Steps.Step2' | translate }}</span>
</ng-template>